var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4971_10133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.95312 -0.0229492C7.17615 -0.0229492 5.72266 1.4535 5.72266 3.23047C5.72266 6.00937 8.5621 9.38463 8.68359 9.52868C8.74515 9.60087 8.85838 9.64502 8.95312 9.64502H8.95474C9.0498 9.6447 9.16143 9.60184 9.22266 9.52868C9.34383 9.38237 12.1758 5.94588 12.1758 3.23047C12.1758 1.4535 10.7301 -0.0229492 8.95312 -0.0229492ZM8.95312 4.81103C8.24124 4.81103 7.66406 4.23386 7.66406 3.52197C7.66406 2.81009 8.24124 2.23291 8.95312 2.23291C9.66501 2.23291 10.2422 2.81009 10.2422 3.52197C10.2422 4.23386 9.66501 4.81103 8.95312 4.81103Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7891 1.96859C15.692 1.91081 15.5508 1.88656 15.3711 1.99593L12.7739 3.40999C12.621 6.22231 10.0021 9.47835 9.69441 9.84928C9.51182 10.0679 9.24495 10.1937 8.95766 10.1947C8.67579 10.1947 8.40924 10.0711 8.22601 9.85534C7.91477 9.48697 5.24963 6.24487 5.14844 3.35531L4.20312 3.78499L0.539062 1.94499C0.440105 1.89583 0.285895 1.91846 0.191406 1.97656C0.0975559 2.03498 0.0195312 2.16828 0.0195312 2.27905V13.7061C0.0195312 13.8706 0.127234 13.9886 0.235449 14.0428L4.01562 15.9375C4.15625 16 4.28107 15.9825 4.37109 15.9375L8.00575 14.1178L11.9754 15.9493C12.0175 15.9687 12.0632 15.9783 12.1088 15.9783C12.1615 15.9783 12.2181 15.9751 12.2656 15.9493L15.8135 14.0134C15.916 13.9576 15.9805 13.8229 15.9805 13.7061V2.28499C15.9805 2.13656 15.8855 2.02605 15.7891 1.96859Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4971_10133"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.3a9be2ff922390cdc279bdf02ca3d54b.svg";
export { ForwardRef as ReactComponent };